<script setup lang="ts">
const { theme, toggleTheme } = usePublicTheme()
const isLight = computed(() => theme.value === 'light')
</script>

<template>
  <span class="public-theme-slot">
    <button
      type="button"
      class="public-theme-toggle"
      data-theme-ready="true"
      :aria-label="isLight ? '切换至暗色主题' : '切换至浅色主题'"
      :title="isLight ? '切换至暗色主题' : '切换至浅色主题'"
      @click="toggleTheme"
    >
      <AppIcon name="sun" class="public-theme-icon public-theme-icon-sun size-[17px]" />
      <AppIcon name="moon" class="public-theme-icon public-theme-icon-moon size-[17px]" />
    </button>
  </span>
</template>
